import {shuffleArray} from "./playUtil.es6";

export default class RandomArrayAdapter {
    constructor() {
        this._list = [];
        this._shuffled = false;
        this.position = 0;
    }

    addAll(iterable) {
        const set = new Set(this._list);
        iterable.forEach(v => set.add(v));

        this._list = Array.from(set);
        this._shuffled = false;
    }

    get empty() {
        return this.size === 0;
    }

    get size() {
        return this._list.length;
    }

    _shuffle() {
        if (this._shuffled) {
            return;
        }

        shuffleArray(this._list);
        this._shuffled = true;
    }

    next() {
        this._shuffle();
        try {
            return this._list[this.position];
        } finally {
            this.position = (this.position + 1) % this.size;
        }
    }
}